import useFeatureCustomization from 'brand-customization/useFeatureCustomization';

const useWidgetSummaryFeatureToggle = () => useFeatureCustomization('widgetSummary');
export default useWidgetSummaryFeatureToggle;
